import { Plus, Save, Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { formatError } from "@/auth";

const EMPTY = { author: "", rating: 5, date: "", text: "" };

function ReviewRow({ r, i, update, remove }) {
  const set = (k) => (e) => update(i, { ...r, [k]: k === "rating" ? Number(e.target.value) : e.target.value });
  return (
    <div className="rva-row" data-testid={`review-row-${i}`}>
      <input placeholder="Nom de l'auteur" value={r.author} onChange={set("author")} data-testid={`review-author-${i}`} />
      <select value={r.rating} onChange={set("rating")} data-testid={`review-rating-${i}`}>{[5, 4, 3, 2, 1].map((n) => <option key={n} value={n}>{`${n} ★`}</option>)}</select>
      <input placeholder="Date (ex. il y a 2 mois)" value={r.date} onChange={set("date")} data-testid={`review-date-${i}`} />
      <button type="button" className="secondary-button" onClick={() => remove(i)} aria-label="Supprimer" data-testid={`review-delete-${i}`}><Trash2 size={15} /></button>
      <textarea rows={3} placeholder="Texte de l'avis (copié depuis Google)" value={r.text} onChange={set("text")} data-testid={`review-text-${i}`} />
    </div>
  );
}

export default function ReviewsAdminPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/site-reviews").then(({ data: d }) => setData(d)).catch(() => {}); }, []);
  if (!data) return null;
  const update = (i, r) => setData({ ...data, reviews: data.reviews.map((x, j) => (j === i ? r : x)) });
  const remove = (i) => setData({ ...data, reviews: data.reviews.filter((_, j) => j !== i) });
  const save = async () => {
    try { const { data: d } = await api.put("/site-reviews", { ...data, rating: Number(data.rating), count: Number(data.count) }); setData(d); toast.success("Avis enregistrés et publiés sur le site."); } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  return (
    <section className="page" data-testid="reviews-admin-page">
      <header className="page-heading"><div><p className="eyebrow">MARKETING</p><h1>Avis Google</h1><p className="page-subtitle">Copiez ici vos avis Google : seuls les avis 4 et 5 étoiles sont affichés sur le site.</p></div>
        <button type="button" className="primary-button" onClick={save} data-testid="reviews-save"><Save size={16} />Enregistrer</button></header>
      <div className="settings-section rva-summary">
        <label>Note moyenne<input type="number" step="0.1" min="0" max="5" value={data.rating} onChange={(e) => setData({ ...data, rating: e.target.value })} data-testid="reviews-admin-rating" /></label>
        <label>Nombre d'avis<input type="number" min="0" value={data.count} onChange={(e) => setData({ ...data, count: e.target.value })} data-testid="reviews-admin-count" /></label>
        <label className="rva-url">Lien vers la page Google<input value={data.url} onChange={(e) => setData({ ...data, url: e.target.value })} data-testid="reviews-admin-url" /></label>
      </div>
      <div className="rva-list">{data.reviews.map((r, i) => <ReviewRow key={i} r={r} i={i} update={update} remove={remove} />)}</div>
      <button type="button" className="secondary-button" onClick={() => setData({ ...data, reviews: [...data.reviews, EMPTY] })} data-testid="reviews-add"><Plus size={16} />Ajouter un avis</button>
    </section>
  );
}
